import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import BLOGS from "@/data/blogs.json";
import { blogIndexJsonLd, readMinutes } from "@/data/blogSeo";
import { PageHero } from "@/components/site/PageHero";
import { IMAGES } from "@/data/site";
import { SITE_URL, useSeo } from "@/lib/seo";

export default function BlogIndex() {
  useSeo({
    title: "Fire Safety Blog for Businesses in India | Vinsafe",
    description: "Practical fire safety guides for facility heads, EHS and procurement teams in India: extinguisher prices, AMC, compliance, alarms, evacuation and more.",
    path: "/blog",
    image: IMAGES.hero,
    jsonLd: blogIndexJsonLd(SITE_URL, BLOGS),
  });
  return (
    <div data-testid="blog-index-page">
      <PageHero eyebrow="Fire safety blog" title="Fire safety guides for Indian businesses." text="Clear, practical answers for facility heads, admin, EHS and procurement teams, from extinguisher prices to compliance across many sites." image={IMAGES.corporate} />
      <section className="container-x py-16">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {BLOGS.map((b) => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="card-base group flex flex-col p-6" data-testid={`blog-card-${b.slug}`}>
              <p className="mono text-[10px] uppercase tracking-[0.18em] text-[#C20500]">{b.keyword}</p>
              <h2 className="mt-3 text-lg font-semibold leading-snug text-slate-900 group-hover:text-[#C20500]" style={{ fontFamily: "Inter, sans-serif" }}>{b.title}</h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{b.meta}</p>
              <p className="mt-5 flex items-center justify-between text-xs text-slate-500">
                <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {readMinutes(b)} min read</span>
                <span className="flex items-center gap-1 font-semibold text-[#C20500]">Read <ArrowRight className="h-3.5 w-3.5" /></span>
              </p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
